/*
 *
 * File: index.js
 *
 * Purpose: Entry point of multistop booking web page.
 *
 * Autor:   Thomas Burgard (Software development)
 * Created: 23.02.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import ReduxStore from "./store";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import common_de from "./translations/de/common.json";
import common_en from "./translations/en/common.json";

// import CSS
//import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import "primereact/resources/themes/md-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./styles/styles.css";

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: "de", // language to use
  resources: {
    en: {
      common: common_en, // 'common' is our custom namespace
    },
    de: {
      common: common_de,
    },
  },
});

//*************************************************************/
//* Returns JSX code                                          */
//*************************************************************/
ReactDOM.render(
  <React.StrictMode>
    <Provider store={ReduxStore()}>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
